import { getAuth } from 'firebase/auth'
import React, { FormEvent, FunctionComponent, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Product } from '../../../pages/DashBoard/DashBoardScreen'
import { useHistory } from 'react-router'
import requestActions from '../../../redux/requests/requestActions'
import * as S from './styled'
import * as Validation from '../../molecules/Validation/ValidationForManualDoc'
import moment from 'moment'
import config from '../../../configurations'
import { eggArrayFirstPart, eggArraySecondPart } from '../CreateEggDocument/CreateEggDocument'
import { ReactComponent as DropDownArrowIcon } from '../../atoms/Icons/DropDownArrow.svg'

type OwnProps = { doc: any }

type Props = OwnProps

export const UpdateEggDocument: FunctionComponent<Props> = doc => {
  const auth = getAuth()
  const user = auth.currentUser
  const dispatch = useDispatch()
  const history = useHistory()
  const [showDetails, setShowDetails] = useState(false)

  function submitHandler(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault()
    const labelsAndInputs = Validation.getLabelAndInputElements(
      event.currentTarget.children[0].children,
    )
    const isValid = Validation.validateInput(
      labelsAndInputs[0] as HTMLLabelElement[],
      labelsAndInputs[1] as HTMLInputElement[],
      'eggs',
    )
    if (isValid) {
      es.uploadedBy = user!.email
      es.id = doc.doc.id
      if (!es.settlementDate) es.settlementDate = doc.doc.settlementDate
      dispatch(requestActions.products.updateDocument(es, Product.EGG, user!.uid))
      history.push('/documents')
    }
  }
  const es: any = {}
  es.data = doc.doc.data
  es.classATotalEggs = doc.doc.classATotalEggs
  es.totalDiscarded = doc.doc.totalDiscarded
  return (
    <>
      {doc.doc.data && (
        <S.Container>
          <S.HeadingStyled>Skapa ny avräkning</S.HeadingStyled>
          <form onSubmit={submitHandler}>
            <S.ParentDiv>
              {eggArrayFirstPart.map((ea, i) => {
                return (
                  <S.ChildDiv key={i}>
                    {ea.icon && <S.IconStyled>{ea.icon}</S.IconStyled>}
                    <S.LabelStyled>{ea.key}</S.LabelStyled>
                    <S.InputStyled
                      defaultValue={doc.doc[ea.agriKey]}
                      max={ea.agriKey === 'settlementDate' ? moment().format('YYYY-MM-DD') : ''}
                      type={ea.type}
                      onChange={e => {
                        es[ea.agriKey] = e.target.value
                        const newType =
                          ea.agriKey === 'buyer'
                            ? 'text'
                            : ea.agriKey === 'settlementDate'
                            ? 'date'
                            : 'number'
                        Validation.validateType(e.currentTarget.value, e.currentTarget, newType)
                      }}
                    ></S.InputStyled>
                  </S.ChildDiv>
                )
              })}
            </S.ParentDiv>
            <div>
              <S.Details onClick={() => setShowDetails(prevValue => !prevValue)}>
                {showDetails ? 'Visa mindre' : 'Klicka för att se fler fält'}
                <DropDownArrowIcon
                  style={{
                    height: '30px',
                    alignItems: 'center',
                    marginLeft: '0.5rem',
                  }}
                />
              </S.Details>
              {showDetails && (
                <S.TableStyled>
                  <thead>
                    <tr>
                      <th>Äggtyp</th>
                      <th>Antal</th>
                      <th>%</th>
                      <th>Pris / st</th>
                      <th>Totalpris</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <S.TableDataStyled>
                        <S.NameBoxStyled
                          text={config.detailsConfig.classASummary.text}
                          bgColor={config.detailsConfig.classASummary.bgColor}
                          type={config.detailsConfig.classASummary.name}
                        />
                        Kvalitetsklass A Total
                      </S.TableDataStyled>
                      <td>
                        <S.InputTableStyled
                          defaultValue={doc.doc.classATotalEggs.amount}
                          type="text"
                          onChange={e => {
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                            es.classATotalEggs.amount = e.target.value
                          }}
                        />
                      </td>
                      <td>
                        <S.InputTableStyled
                          defaultValue={doc.doc.classATotalEggs.percentage}
                          type="text"
                          onChange={e => {
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                            es.classATotalEggs.percentage = e.target.value
                          }}
                        />
                      </td>
                      <td>
                        <S.InputTableStyled
                          defaultValue={doc.doc.classATotalEggs.price}
                          type="text"
                          onChange={e => {
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                            es.classATotalEggs.price = e.target.value
                          }}
                        />
                      </td>
                      <td>
                        <S.InputTableStyled
                          defaultValue={doc.doc.classATotalEggs.totalPrice}
                          type="text"
                          onChange={e => {
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                            es.classATotalEggs.totalPrice = e.target.value
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <S.TableDataStyled>
                        <S.NameBoxStyled
                          text={config.detailsConfig.totalDiscarded.text}
                          bgColor={config.detailsConfig.totalDiscarded.bgColor}
                          type={config.detailsConfig.totalDiscarded.name}
                        />
                        Frånsorterad Total
                      </S.TableDataStyled>
                      <td>
                        <S.InputTableStyled
                          defaultValue={doc.doc.totalDiscarded.amount}
                          type="text"
                          onChange={e => {
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                            es.totalDiscarded.amount = e.target.value
                          }}
                        />
                      </td>
                      <td>
                        <S.InputTableStyled
                          defaultValue={doc.doc.totalDiscarded.percentage}
                          type="text"
                          onChange={e => {
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                            es.totalDiscarded.percentage = e.target.value
                          }}
                        />
                      </td>
                      <td>
                        <S.InputTableStyled
                          defaultValue={doc.doc.totalDiscarded.price}
                          type="text"
                          onChange={e => {
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                            es.totalDiscarded.price = e.target.value
                          }}
                        />
                      </td>
                      <td>
                        <S.InputTableStyled
                          defaultValue={doc.doc.totalDiscarded.totalPrice}
                          type="text"
                          onChange={e => {
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                            es.totalDiscarded.totalPrice = e.target.value
                          }}
                        />
                      </td>
                    </tr>

                    {eggArraySecondPart.map((ea, i) => {
                      // es.data[i] = { type: ea.key }
                      return (
                        <tr key={i}>
                          <S.TableDataStyled>
                            <S.NameBoxStyled
                              text={config.detailsConfig[ea.agriKey].text}
                              bgColor={config.detailsConfig[ea.agriKey].bgColor}
                              type={config.detailsConfig[ea.agriKey].name}
                            />
                            {ea.key}
                          </S.TableDataStyled>
                          <td>
                            <S.InputTableStyled
                              defaultValue={doc.doc.data[i].amount}
                              type="text"
                              onChange={e => {
                                es.data[i] = {
                                  ...es.data[i],
                                  type: ea.agriKey,
                                  amount: e.target.value,
                                }
                                Validation.validateType(
                                  e.currentTarget.value,
                                  e.currentTarget,
                                  'number',
                                )
                              }}
                            />{' '}
                          </td>
                          <td>
                            <S.InputTableStyled
                              defaultValue={doc.doc.data[i].percentage}
                              type="text"
                              onChange={e => {
                                es.data[i] = {
                                  ...es.data[i],
                                  type: ea.agriKey,
                                  percentage: e.target.value,
                                }
                                Validation.validateType(
                                  e.currentTarget.value,
                                  e.currentTarget,
                                  'number',
                                )
                              }}
                            />{' '}
                          </td>
                          <td>
                            <S.InputTableStyled
                              defaultValue={doc.doc.data[i].price}
                              type="text"
                              onChange={e => {
                                es.data[i] = {
                                  ...es.data[i],
                                  type: ea.agriKey,
                                  price: e.target.value,
                                }
                                Validation.validateType(
                                  e.currentTarget.value,
                                  e.currentTarget,
                                  'number',
                                )
                              }}
                            />{' '}
                          </td>
                          <td>
                            <S.InputTableStyled
                              defaultValue={doc.doc.data[i].totalPrice}
                              type="text"
                              onChange={e => {
                                es.data[i] = {
                                  ...es.data[i],
                                  type: ea.agriKey,
                                  totalPrice: e.target.value,
                                }
                                Validation.validateType(
                                  e.currentTarget.value,
                                  e.currentTarget,
                                  'number',
                                )
                              }}
                            />{' '}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </S.TableStyled>
              )}
            </div>
            <S.Button type="submit">Lägg Till</S.Button>
          </form>
        </S.Container>
      )}
    </>
  )
}
export default UpdateEggDocument
